import { trackerLineStyle, trackerMarkerStyle } from "helpers/map";
import React from "react";
import { CircleMarker, Tooltip } from "react-leaflet";
import PolylineDecorator from "./polylineDecorator";

const TrackerRoute = React.memo((props) => {
    const { trackerCoords, trackerStops } = props;
    return (
        <>
            <PolylineDecorator positions={trackerCoords} {...trackerLineStyle} />
            {Object.entries(trackerStops).map(([_, { location, fixedAt }], index) => (
                <CircleMarker key={index} center={location} {...trackerMarkerStyle}>
                    <Tooltip className="map__tooltip--default" direction="top">
                        {new Date(fixedAt).toLocaleString("ru-RU")}
                    </Tooltip>
                </CircleMarker>
            ))}
        </>
    );
});

export default TrackerRoute;
